import * as axios from 'axios';
import * as utils from '../shared/service-utils';

import { API } from '../shared/config';

export default {
  methods: {
    async getCurrentCycleData() {
      try {
        const hdr = await utils.getAuthHeader();
        const response = await axios.get(`${API}/bill-cycle/current`, { headers: hdr });
        const data = this.parseList(response);
        return data;
      } catch (error) {
        console.error(error);
        return [];
      }
    },

    async getPastCycleData() {
      try {
        const hdr = await utils.getAuthHeader();
        const response = await axios.get(`${API}/bill-cycle/past`, { headers: hdr });
        const data = this.parseList(response);
        return data;
      } catch (error) {
        console.error(error);
        return [];
      }
    },

    async getPastBillCycleReturns(userId, idx) {
      try {
        const hdr = await utils.getAuthHeader();
        const response = await axios.get(`${API}/bill-cycle/past/${userId}/returns/${idx}`, { headers: hdr });
        const data = this.parseList(response);
        return data;
      } catch (error) {
        console.error(error);
        return [];
      }
    },

    async getCurrentBillCycleReturns(userId) {
      try {
        const hdr = await utils.getAuthHeader();
        const response = await axios.get(`${API}/bill-cycle/current/${userId}/returns`, { headers: hdr });
        const data = this.parseList(response);
        return data;
      } catch (error) {
        console.error(error);
        return [];
      }
    },

    async getSinglePastCycleData(id) {
      try {
        const hdr = await utils.getAuthHeader();
        const response = await axios.get(`${API}/bill-cycle/past/${id}`, { headers: hdr });
        const data = this.parseList(response);
        return data;
      } catch (error) {
        console.error(error);
        return [];
      }
    },

    async getBillngDocument(userId, billCycle, fileName) {
      try {
        const hdr = await utils.getAuthHeader();
        const req = {
          url: `${API}/get-billing-file/${userId}/${billCycle}/${fileName}`,
          method: 'GET',
          // responseType: 'blob',
          headers: hdr,
        };
        const response = await axios.get(req.url, req);
        console.log('The raw response');
        console.log(response);
        const data = this.parseList(response);
        return data;
      } catch (error) {
        console.error(error);
        return [];
      }
    },

    async updateCycleStatus(payload) {
      try {
        const hdr = await utils.getAuthHeader();
        const response = await axios.post(`${API}/bill-cycle/upcoming/update-status`, payload, { headers: hdr });
        const data = this.parseSingletonResult(response);
        return data;
      } catch (error) {
        console.error(error);
        return {};
      }
    },

    async getPaymentExceptions() {
      try {
        const hdr = await utils.getAuthHeader();
        const response = await axios.get(`${API}/payment-exceptions`, { headers: hdr });
        const data = this.parseSingleton(response);
        return data;
      } catch (error) {
        console.error(error);
        return {};
      }
    },

    async retryPayments(users) {
      try {
        if (!users || users.length === 0) {
          console.error('You must provide at least one user to a request to retry cards.');
          return {};
        }
        const hdr = await utils.getAuthHeader();
        const payload = {
          users,
          trans: 'RetryPayment',
        };
        const response = await axios.post(`${API}/batch/submission-request`, payload, { headers: hdr });
        const data = this.parseSingleton(response);
        return data;
      } catch (error) {
        console.error(error);
        return {};
      }
    },

    async resendDocuments(users) {
      try {
        if (!users || users.length === 0) {
          console.error('You must provide at least one user to a request to resend a document.');
          return {};
        }
        const hdr = await utils.getAuthHeader();
        const payload = {
          users,
          trans: 'ResendDocument',
        };
        const response = await axios.post(`${API}/batch/submission-request`, payload, { headers: hdr });
        const data = this.parseSingleton(response);
        return data;
      } catch (error) {
        console.error(error);
        return {};
      }
    },

    parseList(response) {
      if (response.status !== 200) throw Error(response.message);
      if (!response.data) return [];
      const list = response.data;
      return list;
    },
    parseSingleton(response) {
      if (response.status !== 200) throw Error(response.message);
      if (!response.data) return {};
      return response.data;
    },
  },
};
